export const BACKEND_KEY = 'PersonalInfo';
export const DEFAULT_CHILD = {
  FirstName: '',
  Age: '',
};

export const CHILDREN_CRUD_OVERVIEW = 0;
export const CHILDREN_CRUD_ADD_EDIT = 1;
